import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PuriumAndSustainabilityComponent } from './purium-and-sustainability.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { OurPurityStandardComponent } from './our-purity-standard/our-purity-standard.component';
import { footerModule } from 'app/shared/footer/footer.module';

const routes: Routes = [
    {
        path: 'Environmental-Promise',
        component: PuriumAndSustainabilityComponent,
        pathMatch: 'full',
    },
    {
      path: 'our-purity-standard',
      component: OurPurityStandardComponent,
      pathMatch: 'full',
    }
];

@NgModule({
  declarations: [
    PuriumAndSustainabilityComponent,
    OurPurityStandardComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    SlickCarouselModule,
    footerModule
  ]
})
export class PuriumAndSustainabilityModule { }
